import { render, staticRenderFns } from "./ClientsPage.vue?vue&type=template&id=01d69b9c&scoped=true&"
import script from "./ClientsPage.vue?vue&type=script&lang=js&"
export * from "./ClientsPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientsPage.vue?vue&type=style&index=0&id=01d69b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d69b9c",
  null
  
)

export default component.exports